<template>
  <div class="home-title">
    <div class="container">
      <div class="title-con">
        <!-- <img class="titImg" :class="{pointer: clickTitle}" :src="title" @click="titleToList" /> -->
        <div class="title-name" @click="titleToList">{{ title }}</div>
      </div>
      
      <div class="flex jc">
        <slot name="cate"></slot>
      </div>

      <div class="homeMoreBtn" v-if="showMore" @click="toMore">
        <em>查看更多</em>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-title',
  props: {
    title: String,
    clickTitle: Boolean,
    showMore: Boolean
  },
  data() {
    return {

    }
  },
  methods: {
    toMore() {
      this.$emit('more')
    },
    titleToList() {
      if (this.clickTitle) {
        this.$emit('toList')
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/_config";

.title-con{
  width: 100%;
  height: 69px;
  box-sizing: border-box;
  background: url("/images/homeTitleBg.png") center no-repeat;
  .title-name {
    text-align: center;
    color: #b41717;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 8px;
    line-height: 1;
    padding-left: 8px;
    cursor: pointer;
    @include hoveItem(left);
  }
  .titImg {
    position: relative;
    &.pointer {
      cursor: pointer;
    }
    display: block;
    margin: 0 auto;
    height: 25px;
    transition: all 0.3s;
    @include hoveItem(left);
  }
}
.homeMoreBtn {
  position: absolute;
  right: 0;
  bottom: 15px;
  width: 110px;
  height: 27px;
  line-height: 27px;
  color: #C3A084;
  font-size: 14px;
  float: right;
  text-align: center;
  padding-right: 10px;

  em {
    width: 100%;
    height: 100%;
    display: block;
    border: 1px solid #C3A084;
    position: relative;
    z-index: 2;

    &::before {
      content: "";
      width: 120px;
      height: 14px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }

    &::after {
      content: "";
      width: 3px;
      height: 3px;
      border: 1px solid #C3A084;
      position: absolute;
      transform: rotate(45deg) translate(0, -60%);
      top: 50%;
      right: -1px;
      z-index: 3;
    }
  }

  &::before {
    content: "";
    width: 18px;
    height: 1px;
    background: #C3A084;
    position: absolute;
    left: -19px;
    top: 50%;
    z-index: 3;
  }

  &::after {
    content: "";
    width: 3px;
    height: 3px;
    border: 1px solid #C3A084;
    position: absolute;
    transform: rotate(45deg) translate(0, -60%);
    top: 50%;
    left: -4px;
    z-index: 3;
  }
}
</style>